var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubcontractorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.35 22.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 11.18,
    cy: 11.18,
    r: 9.5,
    style: {
      fill: "none",
      stroke: "#c3c8cf",
      strokeMiterlimit: 10,
      strokeWidth: "1.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77,16.13a5.56,5.56,0,0,1-1.86-.9l.75-1.69a6,6,0,0,0,3.48,1.08,3,3,0,0,0,1.55-.33,1,1,0,0,0,.53-.9.88.88,0,0,0-.49-.8A6.52,6.52,0,0,0,11,12a9.19,9.19,0,0,1-2.26-.7,2.87,2.87,0,0,1-1.23-1A2.63,2.63,0,0,1,7.1,8.83,2.93,2.93,0,0,1,7.64,7.1,3.7,3.7,0,0,1,9.15,5.91a5.47,5.47,0,0,1,2.25-.43,7.37,7.37,0,0,1,2.2.33,4.34,4.34,0,0,1,1.67.9l-.75,1.68a5.18,5.18,0,0,0-3.1-1.07A2.57,2.57,0,0,0,10,7.67a1.12,1.12,0,0,0-.53,1,.89.89,0,0,0,.2.6,1.7,1.7,0,0,0,.69.42,9.92,9.92,0,0,0,1.36.38,7.41,7.41,0,0,1,3,1.17,2.35,2.35,0,0,1,.91,2,2.84,2.84,0,0,1-1.17,2.4,5.39,5.39,0,0,1-3.27.87A8.27,8.27,0,0,1,8.77,16.13Z",
    style: {
      fill: "#c3c8cf"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubcontractorIcon);
export default __webpack_public_path__ + "static/media/subcontractor_icon.0e6d65ce3c7cb80f82fe5388d268140c.svg";
export { ForwardRef as ReactComponent };